export default {
  isBusy: false,
  form: {},
};
